import React from 'react';
import { Grid } from '@mui/material';
import CustomCard1 from '../components/cards/CustomCard1';
import DashStatsWidget from '../components/widgets/DashStatsWidget';
import BranchCarousel from '../components/carousel/BranchCarousel';
import PromoCarousel from '../components/carousel/PromoCarousel';
import DashMinInfoboxes from '../components/DashMinInfoboxes';
import DashMainInfobox from '../components/DashMainInfobox';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from '../assets/utils/colors';
import { reverse, size } from 'lodash';

// RTK query and redux imports
import {
    useGetCategoriesQuery,
    useGetAllSubCategoriesQuery,
} from '../api/categories/categoryAPI';
import { setCategories, setSubCategories } from '../features/categorySlice';
import DashLayout from './layouts/DashLayout';
import DashSidebar from '../components/dash/DashSidebar';
import BrandWidget from '../components/widgets/BrandWidget';
import OrderWidget from '../components/widgets/OrderWidget';

const Dashboard = () => {
    const { data: categories, isSuccess } = useGetCategoriesQuery();
    const {
        data: sub_categories,
        isSuccess: sub_success,
    } = useGetAllSubCategoriesQuery();
    const dispatch = useDispatch();
    const orders = useSelector((state) => state.orders.orders);
    const promotions = useSelector((state) => state.promotions.promotions);
    const branches = useSelector((state) => state.branches.branches);
    const brands = useSelector((state) => state.brands.brands);

    if (isSuccess) {
        dispatch(setCategories({ categories: categories.data }));
    }

    if (sub_success) {
        dispatch(setSubCategories({ sub_categories: sub_categories.data }));
    }

    let promotionCount = 0;
    let branchCount = 0;
    let brandCount = 0;

    if (size(promotions)) {
        promotionCount = size(promotions);
    }

    if (size(branches)) {
        branchCount = size(branches);
    }

    if (size(brands)) {
        brandCount = size(brands);
    }

    return (
        <>
            <DashLayout sidebar={<DashSidebar orders={orders} />}>
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                pb: 3,
                                borderBottom: `2px solid ${colors.bgColor4}`,
                                boxShadow: `-5px 0px 10px 0px ${colors.bgColor3}`,
                            }}
                        >
                            <Grid item sm={3}>
                                <DashStatsWidget />
                            </Grid>
                            <Grid item sm={5.5}>
                                {/* ############## Main infoboxes ########### */}
                                <Grid container spacing={2}>
                                    <DashMainInfobox />
                                </Grid>

                                {/* ############## Sub infoboxes ########### */}
                                <Grid container sx={{ mt: 4 }}>
                                    <DashMinInfoboxes />
                                </Grid>
                            </Grid>
                            <Grid item sm={3.5}>
                                <CustomCard1
                                    title={'Today orders'}
                                    height={275}
                                    borderBottom={true}
                                    url={'/orders'}
                                >
                                    <Grid container>
                                        {reverse(
                                            orders?.map((order, index) => (
                                                <Grid item sm={12} key={index}>
                                                    <OrderWidget
                                                        order={order}
                                                    />
                                                </Grid>
                                            )),
                                        )}
                                    </Grid>
                                </CustomCard1>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12}>
                        <Grid container spacing={3}>
                            <Grid item sm={4.25}>
                                <CustomCard1
                                    height={250}
                                    title={`CAICA promotions (${promotionCount})`}
                                    url={'/promotions'}
                                >
                                    <PromoCarousel promotions={promotions} />
                                </CustomCard1>
                            </Grid>
                            <Grid item sm={4.25}>
                                <CustomCard1
                                    height={250}
                                    title={`CAICA branches (${branchCount})`}
                                    url={'/branches'}
                                >
                                    <BranchCarousel branches={branches} />
                                </CustomCard1>
                            </Grid>
                            <Grid item sm={3.5}>
                                <CustomCard1
                                    title={`Associated brands (${brandCount})`}
                                    url={'/brands'}
                                    height={235}
                                    borderBottom={true}
                                >
                                    <Grid container spacing={2}>
                                        {brands?.map((brand) => (
                                            <Grid item sm={4} key={brand.id}>
                                                <BrandWidget
                                                    brandImage={
                                                        brand.brand_image
                                                    }
                                                    brand_name={
                                                        brand.brand_name
                                                    }
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </CustomCard1>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DashLayout>
        </>
    );
};

export default Dashboard;
